const cls = {
  /** No Classes */
  no_classes_are_scheduled_in_which_you_re_a_class_in_charge:
    "No classes are scheduled in which you're a class in-charge",
  click_here_to_launch_acadly_s_web_application_and_create_a_class:
    "Click <2>here</2> to launch Acadly's web application and create a class",

  /** Class Widget */
  class_in_charge: 'Class in-charge',
  N_planned_polls_one: '{{count}} planned poll',
  N_planned_polls_other: '{{count}} planned polls',
  N_marked_present: '{{count}} marked present',
  D_from_now: '{{distance}} from now',

  /** Attendance */
  time_to_record_attendance: 'Time to record attendance',
  select_the_lecture: 'Select the lecture',
  these_are_the_relevant_scheduled_lectures_in_your_courses_that_are_currently_in_session_and_availble_for_recording_attendance:
    'These are the relevant scheduled lectures in your courses that are currently in-session and availble for recording attendance',
  no_lectures_are_in_session_right_now: 'No lectures are in-session right now',
  acadly_cannot_find_any_scheduled_lectures_in_your_course_that_are_in_session_right_now_whenever_attendance_is_being_recorded_during_a_scheduled_lecture_you_will_be_able_to_proceed_by_selecting_the_appropriate_lecture:
    ' Acadly cannot find any scheduled lectures in your course that are in-session right now. Whenever attendance is being recorded during a scheduled lecture, you will be able to proceed by selecting the appropriate lecture',
  next_lecture_in_which_attendance_can_be_recorded: 'Next lecture in which attendance can be recorded',
  recording_attendance: 'Recording attendance',
  attendance_recorded: 'Attendance recorded',
  click_a_button_to_record_attendance_of_everyone_sitting_in_the_lecture_hall_using_acadly_s_proprietary_mesh_network_based_technology:
    "Click a button to record attendance of everyone sitting in the lecture hall using Acadly's proprietary mesh network based technology",
  please_ensure: 'Please ensure',
  acadly_app_is_open_on_your_phone: 'Acadly app is open on your phone',
  your_phone_is_connected_to_the_internet: 'Your phone is connected to the internet',
  you_are_logged_in_to_acadly: 'You are logged in to Acadly',
  acadly_app_has_all_required_permissions: 'Acadly app has all required permissions',
  record_attendance: 'Record Attendance',
  class_starts_on_date_time: 'Class starts on {{dateTime}}',
  class_starts_in_time: 'Class starts in {{time}}',
  class_not_in_session: 'Class not in session',
  attendance_summary: 'Attendance Summary',
  number_of_attempts: 'Number of attempts',
  students_marked_present: 'Students marked “Present”',
  retake_attendance: 'Retake Attendance',
  num_students_have_the_app_closed: '{{number}} students have the app closed',
  time_remaining: 'Time remaining',
  marked_present: 'Marked present',
  reset_attendance: 'Reset attendance',

  /** Attendance slide */
  attendance_was_not_recorded: 'Attendance was not recorded',
  // DO NOT USE \n as it raises many bugs in PowerPoint code
  attendance_was_recorded_in_lecture_scheduled_at_date_and_time_url:
    'Attendance was recorded in lecture scheduled at {{dateAndTime}} \r {{url}}',

  /** Errors */
  unable_to_fetch_classes: 'Unable to fetch classes',
} as const;

export default cls;
